module.exports = __webpack_public_path__ + "static/media/cameraSetting.4dcc534c.png";